import React from 'react';
import FiltersDrawer from '../../../components/FiltersDrawer';
import { SEC_FILTER_DEFAULTS } from '../utils/secFilingFilters';

export default function SecFilingFiltersDrawer({
  isOpen,
  onClose,
  filters,
  setCurrentPage,
}) {
  const {
    filterCompany,
    setFilterCompany,
    filterFormType,
    setFilterFormType,
    filedStart,
    setFiledStart,
    filedEnd,
    setFiledEnd,
    tempFiledRange,
    setTempFiledRange,
    formTypes,
    companyCatalog,
  } = filters;

  return (
    <FiltersDrawer
      isOpen={isOpen}
      onClose={onClose}
      visibleSections={['company', 'type', 'submissionDates']}
      filterDefaults={SEC_FILTER_DEFAULTS}
      filingTypeTitle="Filing type"
      filingTypeSearchPlaceholder="Search form types"
      submissionDateTitle="Filed dates"
      resetButtonLabel="Reset"
      applyButtonLabel="Apply"
      showSubmissionDates
      filterState="All states"
      setFilterState={() => {}}
      filterStatus="All statuses"
      setFilterStatus={() => {}}
      filterType={filterFormType}
      setFilterType={setFilterFormType}
      filterToi="All TOI"
      setFilterToi={() => {}}
      filterCompany={filterCompany}
      setFilterCompany={setFilterCompany}
      subStart={filedStart}
      setSubStart={setFiledStart}
      subEnd={filedEnd}
      setSubEnd={setFiledEnd}
      tempSubRange={tempFiledRange}
      setTempSubRange={setTempFiledRange}
      options={{
        states: [],
        filingTypes: formTypes,
        companies: companyCatalog,
        xbrlTags: [],
      }}
      statuses={[]}
      tois={[]}
      setCurrentPage={setCurrentPage}
    />
  );
}
